// SidebarContext.js
import React, { createContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const StoreStepperContext = createContext();

export const StoreStepperProvider = ({ children }) => {
  const [storeformData, setStoreFormData] = useState({
    storeID: uuidv4(),
    storeName: "",
    storeImages: [],
    storeLocation: "",
    storeDescription: "",
    storeCurrency: "",
    storeWeight: "",
    storeShipment: "",
    storeCreatedDate: new Date(),
    products: [
      // {
      //   productBrand: "",
      //   productCategory: "",
      //   productImage: "",
      //   productDescription: "",
      //   productDimensionH: 0,
      //   productDimensionL: 0,
      //   productDimensionW: 0,
      //   productName: "",
      //   productPrice: 0,
      //   productStock: 0,
      //   productTag: "",
      //   productWeight: 0,
      //   productVarient: [],
      // },
    ],
  });
  const [productCatalogData, setProductCatalogData] = useState({
    productType: false,
    parcelName: "",
    totalWeight: "",
    fullPrice: "",
    parcelPrice: "",
    parcelProducts: [],
    storeImages: [],
    productBrand: "",
    productCategory: "",
    productImage: "",
    productDescription: "",
    productDimentionH: 0,
    productDimentionL: 0,
    productDimentionW: 0,
    productName: "",
    productPrice: 0,
    productStock: 0,
    productWeight: 0,
    productVarient: [],
    productKeyFeatures: "",
    productUseCase: "",
    productBenefits: "",
    productNutritionalValue: "",
    productProductSpecifications: "",
    productTags: [],
    productDesignation: "",
  });
  const [stepperActiveStep, setStepperActiveStep] = useState(0);
  const [saveContinueBtn, setSaveContinueBtn] = useState(false);
  const [checkForEdit, setCheckForEdit] = useState(false);
  const [productIdForEdit, setProductIdForEdit] = useState("");
  const [addProductFromOverview, setAddProductFromOverview] = useState(false);
  const [addProductForMasterList, setAddProductForMasterList] = useState(false);
  const [addProductFromOverviewDocId, setAddProductFromOverviewDocId] =
    useState();
  const [productCatalog, setProductCatalog] = useState(false);
  const [brandReload, serBrandReload] = useState(false);
  const [products, setProducts] = useState([]);

  return (
    <StoreStepperContext.Provider
      value={{
        storeformData,
        setStoreFormData,
        stepperActiveStep,
        setStepperActiveStep,
        saveContinueBtn,
        setSaveContinueBtn,
        checkForEdit,
        setCheckForEdit,
        productIdForEdit,
        setProductIdForEdit,
        addProductFromOverview,
        setAddProductFromOverview,
        addProductFromOverviewDocId,
        setAddProductFromOverviewDocId,
        addProductForMasterList,
        setAddProductForMasterList,
        productCatalog,
        setProductCatalog,
        brandReload,
        serBrandReload,
        products,
        setProducts,
        productCatalogData,
        setProductCatalogData,
      }}
    >
      {children}
    </StoreStepperContext.Provider>
  );
};

export default StoreStepperContext;
